/* import __COLOCATED_TEMPLATE__ from './trending-topics-conversation-panel.hbs'; */
/* RESPONSIBLE TEAM: team-ai-insights */
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import type { TrendingTopicConversation } from 'embercom/components/reporting/automation/ai-insights/trending-topics-key-conversations';
import type AppService from 'embercom/services/app-service';

interface Signature {
  Args: {
    isOpen: boolean;
    onClose: () => void;
    loadedConversations: TrendingTopicConversation[];
    initialSelectedConversationId: number | undefined;
    isStandalone: boolean;
    trackAnalyticsEvent: (
      action: string,
      object: string,
      extraContext: Record<string, any>,
    ) => void;
  };
  Blocks: {
    header: [];
  };
}

export default class TrendingTopicsConversationPanel extends Component<Signature> {
  @service declare appService: AppService;

  @tracked internalSelectedConversationId: number | undefined;

  get selectedConversationId() {
    return (
      this.internalSelectedConversationId ??
      this.args.initialSelectedConversationId ??
      this.args.loadedConversations[0]?.id
    );
  }

  get totalHits() {
    return this.args.loadedConversations.length;
  }

  @action
  onConversationSelected(conversationId: number) {
    this.internalSelectedConversationId = conversationId;
  }

  @action
  loadMoreConversations() {
    // No-op: All conversations are loaded upfront
  }

  @action
  handleClose() {
    this.internalSelectedConversationId = undefined;
    this.args.onClose();
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Reporting::Automation::AiInsights::TrendingTopicsConversationPanel': typeof TrendingTopicsConversationPanel;
    'reporting/automation/ai-insights/trending-topics-conversation-panel': typeof TrendingTopicsConversationPanel;
  }
}
